import { createLeadWithTracking } from "../../shared/openaiLeadTracking.mjs";
// 'use client';
import { useState, useEffect } from "react";
import ResultModal from "@/components/homes/heros/ResultModal";
import axios from "axios";
import { toast } from "react-toastify";
import { trackLeadHybrid } from "@/lib/metaLeadTracking";
import LeadOtpVerification from "@/components/common/LeadOtpVerification";

export default function RankForm({
  onClose,
  marks,
  setPredictedRanks,
  showResultModal,
  setShowResultModal,
  setShowLoadingModal,
  predictedRanks,
}) {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    neetScore: marks || "",
    leadSource: "Rank_Prediction_Form",
  });
  const [submitting, setSubmitting] = useState(false); // Add submitting state
  const [isOtpVerified, setIsOtpVerified] = useState(false);

  const saveLeadSubmittedWithExpiry = () => {
    const now = new Date();
    const expiry = now.getTime() + 6 * 30 * 24 * 60 * 60 * 1000; // 6 months in ms
    const data = {
      value: true,
      expiry,
    };
    localStorage.setItem("leadSubmitted", JSON.stringify(data));
  };

  // Keep formData.neetScore in sync with marks prop only on first mount
  useEffect(() => {
    if (marks && !formData.neetScore) {
      setFormData((prev) => ({ ...prev, neetScore: marks }));
    }
    // eslint-disable-next-line
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return; // Prevent multiple submits
    if (!isOtpVerified) {
      toast.error("Please verify your phone via WhatsApp OTP before submitting.");
      return;
    }
    setSubmitting(true);
    try {
      const ADMIN_URL = process.env.NEXT_PUBLIC_ADMIN_URL;
      const name = `${formData.firstName} ${formData.lastName}`.trim();
      await createLeadWithTracking(`${ADMIN_URL}/api/leads`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-secret-key": process.env.NEXT_PUBLIC_SECRET_KEY,
        },
        body: JSON.stringify({
          name,
          email: formData.email,
          phone: "+91" + formData.phone,
          leadSource: formData.leadSource,
          neetScore: formData.neetScore,
          // leadSource,
        }),
      });
        // stop syanamte submission
        // await axios.post(
        //   `${process.env.NEXT_PUBLIC_API_URL}/api/contacts/upsert`,
        //   {
        //     firstName: formData.firstName,
        //     lastName: formData.lastName,
        //     email: formData.email,
        //     phone: "+91" + formData.phone,
        //     tags: formData.leadSource,
        //     neetScore: formData.neetScore,
        //   }
        // );

      await trackLeadHybrid({
        email: formData.email,
        phone: formData.phone,
        value: 49,
        currency: "INR",
        eventSourceUrl: "/thank-you",
        dedupeKey: `${formData.leadSource}_${formData.phone}_${formData.email}`,
        customData: {
          lead_source: formData.leadSource,
          neet_score: formData.neetScore,
        },
      });

      saveLeadSubmittedWithExpiry();

      const API_URL = process.env.NEXT_PUBLIC_API_URL;

      setShowLoadingModal(true);
      const response = await fetch(`${API_URL}/api/predict-rank`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-secret-key": process.env.NEXT_PUBLIC_SECRET_KEY,
        },
        body: JSON.stringify({ marks: parseInt(formData.neetScore, 10) }), // use updated neetScore
      });

      const data = await response.json();
      const predictedRank = data.predicted_rank;
      const confidenceLower =
        predictedRank === 1 ? 1 : Math.max(1, Math.round(predictedRank - 25));
      const confidenceUpper = Math.round(predictedRank + 25);
      const confidenceRange = `${confidenceLower} - ${confidenceUpper}`;

      setPredictedRanks([
        {
          marks: formData.neetScore, // use updated neetScore
          predictedRank,
          confidenceRange,
          previousYearRanks: data.previousYearRanks || {},
        },
      ]);

      setTimeout(() => {
        setShowLoadingModal(false);
        onClose();
        setShowResultModal(true);
        setSubmitting(false); // Reset submitting after done
      }, 2000);
    } catch (error) {
      console.error("Form Predict Error:", error);
      toast.error("Error predicting rank. Please try again.");
      setSubmitting(false); // Reset submitting on error
      setShowLoadingModal(false);
    }
  };

  return (
    <>
      <div className="bg-white w-full max-w-2xl mx-auto rounded-xl p-6 sm:p-6 shadow-md border border-[#ff9245] border-xl sm:px-12">
        <h2 className="text-center text-lg sm:text-xl font-semibold text-[#1A374D] m-4 sm:mb-8">
          Fill your details to get Your rank
        </h2>
        <form onSubmit={handleSubmit} className="space-y-3">
          <div className="flex flex-col sm:flex-row sm:space-x-2 space-y-2 sm:space-y-0">
            <input
              name="firstName"
              placeholder="First Name"
              className="flex-1 p-2 border rounded text-[#000]"
              onChange={handleChange}
              required
            />
            <input
              name="lastName"
              placeholder="Last Name"
              className="flex-1 p-2 border rounded text-[#000]"
              onChange={handleChange}
              required
            />
          </div>
          <input
            name="email"
            type="email"
            placeholder="Email"
            className="w-full p-2 border rounded text-[#000]"
            onChange={handleChange}
            required
          />
          <LeadOtpVerification
            phone={formData.phone}
            otpEnabled={false}
            onPhoneChange={(value) => setFormData((prev) => ({ ...prev, phone: value }))}
            inlinePhoneField
            countryCodePrefix="+91"
            phonePlaceholder="Phone Number"
            onVerifiedChange={setIsOtpVerified}
          />
          <input
            name="neetScore"
            type="number"
            placeholder="neetScore"
            className="w-full p-2 border rounded text-[#000]"
            value={formData.neetScore}
            onChange={handleChange}
            required
          />
          <div className="flex items-center justify-center">
            <button
              type="submit"
              className="w-full sm:w-auto px-6 bg-orange-400 text-white py-2 rounded-3xl hover:bg-[#fff] hover:ring-1 hover:ring-[#ff9245] hover:!text-[#ff9245] transition duration-300 ease-in-out text-base sm:text-lg"
              disabled={submitting} // Disable button while submitting
            >
              {submitting ? "Submitting..." : "➜ Submit"}
            </button>
          </div>
        </form>
      </div>
      <ResultModal
        predictedRanks={predictedRanks}
        showResultModal={showResultModal}
        setShowResultModal={(val) => {
          setShowResultModal(val);
          if (!val && typeof onClose === "function") onClose();
        }}
      />
    </>
  );
}
